import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface HeroSocialProofProps {
  align?: "center" | "left" | "right";
  mobileAlign?: "left";
}

export function HeroSocialProof({ align = "center", mobileAlign }: HeroSocialProofProps) {
  return (
    <div
      className={cn(
        "mb-3 grid gap-1 sm:flex sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-3 sm:gap-y-1",
        align === "center" &&
          (mobileAlign === "left"
            ? "justify-items-start sm:justify-center"
            : "justify-items-center sm:justify-center"),
        (align === "left" || align === "right") && "justify-items-start sm:justify-start lg:justify-items-start lg:justify-start",
      )}
    >

      <div className="flex shrink-0 items-center gap-1">
        <svg
          className="h-5 w-5 shrink-0"
          viewBox="0 0 48 48"
          aria-label="Google"
        >
          <path
            fill="#EA4335"
            d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
          />
          <path
            fill="#4285F4"
            d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
          />
          <path
            fill="#FBBC05"
            d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
          />
          <path
            fill="#34A853"
            d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
          />
        </svg>
        <div className="flex items-center gap-0">
          {Array.from({ length: 5 }).map((_, i) => (
            <span key={i} className="relative flex h-5 w-5 items-center justify-center">
              <Star className="relative h-4 w-4 fill-yellow-400 text-yellow-400" />
            </span>
          ))}
        </div>
        <span className="text-sm font-semibold text-foreground">5.0</span>
      </div>
    </div>
  );
}
